module.exports = __webpack_public_path__ + "quilt2-level4.f667b3fe.png";